import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

const CLIENT_APP_DEEP_LINK = 'com.anihis.app://dashboard';
const APP_STORE_URL = 'https://apps.apple.com/app/anihis/id0000000000';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.anihis.app';
const COUNTDOWN_SECONDS = 5;

@Component({
  selector: 'anihis-confirm-share',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './confirm-share.component.html',
  styleUrl: './confirm-share.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmShareComponent implements OnInit, OnDestroy {
  countdown = signal(COUNTDOWN_SECONDS);

  private countdownInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  openApp(): void {
    window.location.href = CLIENT_APP_DEEP_LINK;
  }

  getAppStoreUrl(): string {
    const ua = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(ua) ? APP_STORE_URL : PLAY_STORE_URL;
  }

  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      const next = this.countdown() - 1;
      this.countdown.set(next);
      if (next <= 0) {
        clearInterval(this.countdownInterval!);
        this.countdownInterval = null;
        window.location.href = CLIENT_APP_DEEP_LINK;
      }
    }, 1000);
  }
}
